import { ISO6391LanguageCode } from './types';

export function isSupportedLocale(
    currentBrowserLocale: string,
): currentBrowserLocale is ISO6391LanguageCode {
    return Object.keys(ISO6391LanguageCode).includes(currentBrowserLocale);
}
